export const retailerDataList = (props) => {
  const { mainStateDashboard, mockList = false } = props

  const { fetchAPIRetailerList } = mainStateDashboard

  console.log("fetchAPIRetailerList", fetchAPIRetailerList)

  return fetchAPIRetailerList?.docs
}
